import { useEffect } from 'react';
import { DoubleSide, MeshBasicMaterial } from 'three';

import { LayerType } from 'app/modules/wallforming/components/scenes/camera-controls/types/layerType';
import { usePoiBatchedMeshHandler } from 'app/modules/wallforming/components/scenes/objects/pois/hooks/usePoiBatchedMeshHandler';
import { PoiGeometryType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiMeshType';
import { createPoiGeometryByType } from 'app/modules/wallforming/components/scenes/objects/pois/utils/poiUtils';

import type { PoiBatchedEntry } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiBatchedEntry';

const poiMaterial = new MeshBasicMaterial({
    side: DoubleSide,
    polygonOffset: true,
    polygonOffsetFactor: -1,
    polygonOffsetUnits: -4
});

const geometryByType = createPoiGeometryByType(PoiGeometryType.FACES);

interface PoiFacesProps {
    entries: PoiBatchedEntry[];
}

export const PoiFaces = ({ entries }: PoiFacesProps) => {
    const { handleMeshRef, handleOnPoiSelection, handleOnPointerMove, handleOnPointerLeave } = usePoiBatchedMeshHandler({
        entries,
        geometriesByType: geometryByType
    });

    useEffect(() => {
        return () => poiMaterial?.dispose();
    }, []);

    if (entries.length === 0) {
        return null;
    }

    return (
        <batchedMesh
            ref={handleMeshRef}
            args={[40_000, 40_000, 40_000, poiMaterial]}
            layers={[LayerType.RAYCAST]}
            name="poi-interaction-target"
            perObjectFrustumCulled={true}
            renderOrder={100}
            onPointerDown={handleOnPoiSelection}
            onPointerLeave={handleOnPointerLeave}
            onPointerMove={handleOnPointerMove}
        />
    );
};
